"use client";
import { cn } from "@/utils/utils";
import React, { useEffect, useState } from "react";
import {
  EmailShareButton,
  EmailIcon,
  FacebookIcon,
  FacebookShareButton,
  LinkedinShareButton,
  LinkedinIcon,
  TelegramShareButton,
  TelegramIcon,
  TwitterShareButton,
  TwitterIcon,
  FacebookMessengerIcon,
  FacebookMessengerShareButton,
} from "react-share";
import PopupDefault from "./PopupDefault";
import ShareSocialIcon from "./icons/ShareSocialIcon";
import InputBorder from "./ui/InputBorder";
import Button from "./ui/Button";
import { useForm } from "react-hook-form";
import { toast } from "sonner";

type ShareComponentType =
  | "facebook"
  | "telegram"
  // | "email"
  | "linkedin"
  | "twitter"
  // | "facebookMessenger" /* thêm các loại khác nếu cần */;
const allComponents: ShareComponentType[] = [
  "facebook",
  // "facebookMessenger",
  "telegram",
  // "email",
  "linkedin",
  "twitter",
];

interface ShareButtonProps {
  url: string;
  title?: string;
}
interface ShareIconProps {
  size?: number;
  round?: boolean;
  borderRadius?: number;
}
interface Props {
  components?: ShareComponentType[];
  className?: string;
  shareButtonProps: ShareButtonProps;
  shareIconProps?: ShareIconProps;
  iconShare?: React.ReactNode;
}

export default function ShareSocial({
  components = allComponents,
  shareButtonProps,
  shareIconProps = {
    round: true,
    size: 34,
  },
  className,
  iconShare,
}: Props) {
  const [open, setOpen] = useState(false);
  const { control, reset, setValue, getValues } = useForm({
    defaultValues: {
      url: shareButtonProps.url,
    },
  });

  useEffect(() => {
    setValue("url", shareButtonProps.url);
  }, [shareButtonProps.url]);
  const renderShareButton = (
    type: ShareComponentType,
    shareButtonProps: ShareButtonProps,
    shareIconProps: ShareIconProps
  ) => {
    switch (type) {
      case "facebook":
        return (
          <FacebookShareButton {...shareButtonProps}>
            <FacebookIcon {...shareIconProps} />
          </FacebookShareButton>
        );
      case "telegram":
        return (
          <TelegramShareButton {...shareButtonProps}>
            <TelegramIcon {...shareIconProps} />
          </TelegramShareButton>
        );
      // case "email":
      //   return (
      //     <EmailShareButton {...shareButtonProps}>
      //       <EmailIcon {...shareIconProps} />
      //     </EmailShareButton>
      //   );
      case "linkedin":
        return (
          <LinkedinShareButton {...shareButtonProps}>
            <LinkedinIcon {...shareIconProps} />
          </LinkedinShareButton>
        );
      case "twitter":
        return (
          <TwitterShareButton {...shareButtonProps}>
            <TwitterIcon {...shareIconProps} />
          </TwitterShareButton>
        );
      // case "facebookMessenger":
      //   return (
      //     <FacebookMessengerShareButton
      //       appId="521270401588372"
      //       {...shareButtonProps}
      //     >
      //       <FacebookMessengerIcon {...shareIconProps} />
      //     </FacebookMessengerShareButton>
      //   );
      // Add other cases as needed
      default:
        return null;
    }
  };

  function copyText() {
    try {
      const text = getValues("url");
      navigator.clipboard.writeText(text);
      toast.success("Sao chép thành công");
    } catch (error) {
      toast.error("Có lỗi xảy ra vui lòng thử lại");
    }
  }
  return (
    <>
      <span
        onClick={() => {
          setOpen(true);
        }}
        className="  cursor-pointer w-fit"
      >
        {iconShare || <ShareSocialIcon />}
      </span>

      <PopupDefault
        open={open}
        onClose={() => {
          reset();
          setOpen(false);
        }}
        classNameBody="w-[90vw] md:w-[500px] rounded-[8px]"
        closeOnMark={false}
      >
        <h4 className="text-2xl font-medium mb-4">Share</h4>
        <div className="flex gap-2 mb-4">
          <div className="flex-1">
            <InputBorder name="url" control={control} />
          </div>
          <div>
            <Button className="h-full cursor-pointer" onClick={copyText}>
              Sao chép
            </Button>
          </div>
        </div>
        <div className={cn("justify-center flex gap-4", className)}>
          {components.map((com, index) => (
            <React.Fragment key={index}>
              {renderShareButton(com, shareButtonProps, shareIconProps)}
            </React.Fragment>
          ))}
        </div>
      </PopupDefault>
    </>
  );
}
